const language = {
    'pt': {
        aaa: 'Grupo ASSEC',
        abstract: 'Subtítulo',
        add_new: 'Adicionar novo',
        archive: 'Arquivo',
        avaiable: 'Disponível até',
        back: ' Voltar ',
        cancel: 'Cancelar', back: 'Voltar',
        choose_category: 'Pressione ENTER para escolher a categoria',
        close: 'Fechar',
        content: 'Notícias',
        content_add: 'Adicionar bloco',
        content_edit: 'Editar conteúdo',
        content_list: 'Lista de notícias',
        content_new: 'Novo conteúdo',
        content_view: 'Conteúdo',
        creation: 'Data de Criação',
        dates: 'Datas',
        date_avaiable: 'Disponível até',
        date_creation: 'Criação',
        date_last_update: 'Última atualização',
        date_publication: 'Publicação',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Continuar?',
        delete_title: 'Eliminar registo',
        description: 'Descrição',
        doc_choose: 'Carregar PDFs',
        draft: 'Rascunho',
        edit: 'Editar',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao atualizar registo!',
        edit_success: 'Registo atualizado com sucesso!',
        edit_text: 'Continuar?',
        edit_title: 'Editar registo',
        file_attach: 'Attach file',
        file_remove_all: 'Remove all',
        file_upload: 'Upload file',
        file_upload_all: 'Upload all',
        filter_placeholder: 'Procurar',
        id: 'ID',
        image: 'Imagem em destaque',
        image_choose: 'Carregar imagens',
        images: 'Imagens',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Continuar?',
        insert_title: 'Novo registo',
        last_mod: 'Última Modificação',
        layout: 'Tipo',
        multimedia: 'Multimédia',
        name: 'Nome',
        name_placeholder: 'Introduza o nome',
        news: 'Notícias',
        news_add: 'Adicionar bloco',
        news_edit: 'Editar notícia',
        news_list: 'Lista de notícias',
        news_new: 'Nova notícia',
        next: ' Próxima ',
        page_config: 'Configuração da Página',
        page_parent: 'Parent',
        pages: 'Páginas',
        pdf_documents: 'Documentos PDF',
        preview: 'Pré-visualização',
        previous: ' Anterior ',
        principal: 'Principal',
        published: 'Publicado',
        remove: 'Remover',
        resume: 'Resumo',
        save: 'Salvar',
        schedule: 'Agendar',
        schedule_to: 'Agendado',
        seo_config: 'Configuração SEO',
        seo_description: 'Descrição SEO',
        seo_description_placeholder: 'Introduza a descrição SEO',
        seo_keywords: 'Palavras-chave SEO',
        seo_keywords_placeholder: 'Introduza as palavras-chave',
        seo_keywords_small: '(separar por vírgulas)',
        seo_title: 'Título SEO',
        seo_title_placeholder: 'Introduza o título SEO',
        source_image: 'Foto',
        source_text: 'Fonte',
        subtitle: 'Subtítulo',
        subtitle_placeholder: 'Introduza o subtítulo',
        table_actions: 'Ações',
        table_all: 'Todos',
        table_date: 'Data',
        table_date_modified: 'Data de alteração',
        table_date_published: 'Data de publicação',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_title: 'Título',
        text: 'Corpo da notícia',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        upload_file_error: 'O ficheiro tem mais de 10MB.',
        youtube_choose: 'Youtube',
        autor:'Publicado por'
    },
    'en': {
        autor:'Published by',
        aaa: 'ASSEC Group',
        abstract: 'Subtitle',
        add_new: 'Add new',
        archive: 'Archive',
        avaiable: 'Available until',
        back: ' Back ',
        cancel: 'Cancel',
        choose_category: 'Press ENTER to choose the category',
        close: 'Close',
        content: 'News',
        content_add: 'Add block',
        content_edit: 'Edit content',
        content_list: 'News list',
        content_new: 'New content',
        content_view: 'Content',
        creation: 'Creation Date',
        dates: 'Dates',
        date_avaiable: 'Available until',
        date_creation: 'Creation',
        date_last_update: 'Last update',
        date_publication: 'Publication',
        delete: 'Delete',
        delete_cancel: 'No',
        delete_confirm: 'Yes',
        delete_error: 'Problem deleting record!',
        delete_success: 'Record deleted successfully!',
        delete_text: 'Continue?',
        delete_title: 'Delete record',
        description: 'Description',
        doc_choose: 'Upload PDFs',
        draft: 'Draft',
        edit: 'Edit',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Problem updating record!',
        edit_success: 'Record updated successfully!',
        edit_text: 'Continue?',
        edit_title: 'Edit record',
        file_attach: 'Attach file',
        file_remove_all: 'Remove all',
        file_upload: 'Upload file',
        file_upload_all: 'Upload all',
        filter_placeholder: 'Search',
        id: 'ID',
        image: 'Featured image',
        image_choose: 'Upload images',
        images: 'Images',
        insert_cancel: 'No',
        insert_confirm: 'Yes',
        insert_error: 'Problem inserting record!',
        insert_success: 'Record inserted successfully!',
        insert_text: 'Continue?',
        insert_title: 'New record',
        last_mod: 'Last Modification',
        layout: 'Type',
        multimedia: 'Multimedia',
        name: 'Name',
        name_placeholder: 'Enter the name',
        news: 'News',
        news_add: 'Add block',
        news_edit: 'Edit news',
        news_list: 'News list',
        news_new: 'New news',
        next: ' Next ',
        page_config: 'Page Configuration',
        page_parent: 'Parent',
        pages: 'Pages',
        pdf_documents: 'PDF Documents',
        preview: 'Preview',
        previous: ' Previous ',
        principal: 'Main',
        published: 'Published',
        remove: 'Remove',
        resume: 'Summary',
        save: 'Save',
        schedule: 'Schedule',
        schedule_to: 'Scheduled',
        seo_config: 'SEO Configuration',
        seo_description: 'SEO Description',
        seo_description_placeholder: 'Enter the SEO description',
        seo_keywords: 'SEO Keywords',
        seo_keywords_placeholder: 'Enter the keywords',
        seo_keywords_small: '(separate with commas)',
        seo_title: 'SEO Title',
        seo_title_placeholder: 'Enter the SEO title',
        source_image: 'Photo',
        source_text: 'Source',
        subtitle: 'Subtitle',
        subtitle_placeholder: 'Enter the subtitle',
        table_actions: 'Actions',
        table_all: 'All',
        table_date: 'Date',
        table_date_modified: 'Modification date',
        table_date_published: 'Publication date',
        table_parent: 'Parent',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_state: 'Status',
        table_title: 'Title',
        text: 'News body',
        title: 'Title',
        title_placeholder: 'Enter the title',
        upload_file_error: 'The file is larger than 10MB.',
        youtube_choose: 'YouTube'
    },
    'es': {
        autor: 'Publicado por',
        aaa: 'Grupo ASSEC',
        abstract: 'Subtítulo',
        add_new: 'Añadir nuevo',
        archive: 'Archivo',
        avaiable: 'Disponible hasta',
        back: ' Volver ',
        cancel: 'Cancelar', back: 'Voltar',
        choose_category: 'Presione ENTER para elegir la categoría',
        close: 'Cerrar',
        content: 'Noticias',
        content_add: 'Añadir bloque',
        content_edit: 'Editar contenido',
        content_list: 'Lista de noticias',
        content_new: 'Nuevo contenido',
        content_view: 'Contenido',
        creation: 'Fecha de creación',
        dates: 'Fechas',
        date_avaiable: 'Disponible hasta',
        date_creation: 'Creación',
        date_last_update: 'Última actualización',
        date_publication: 'Publicación',
        delete: 'Eliminar',
        delete_cancel: 'No',
        delete_confirm: 'Sí',
        delete_error: '¡Problema al eliminar el registro!',
        delete_success: '¡Registro eliminado con éxito!',
        delete_text: '¿Continuar?',
        delete_title: 'Eliminar registro',
        description: 'Descripción',
        doc_choose: 'Cargar PDFs',
        draft: 'Borrador',
        edit: 'Editar',
        edit_cancel: 'No',
        edit_confirm: 'Sí',
        edit_error: '¡Problema al actualizar el registro!',
        edit_success: '¡Registro actualizado con éxito!',
        edit_text: '¿Continuar?',
        edit_title: 'Editar registro',
        file_attach: 'Adjuntar archivo',
        file_remove_all: 'Eliminar todo',
        file_upload: 'Subir archivo',
        file_upload_all: 'Subir todos',
        filter_placeholder: 'Buscar',
        id: 'ID',
        image: 'Imagen destacada',
        image_choose: 'Subir imágenes',
        images: 'Imágenes',
        insert_cancel: 'No',
        insert_confirm: 'Sí',
        insert_error: '¡Problema al insertar el registro!',
        insert_success: '¡Registro insertado con éxito!',
        insert_text: '¿Continuar?',
        insert_title: 'Nuevo registro',
        last_mod: 'Última modificación',
        layout: 'Tipo',
        multimedia: 'Multimedia',
        name: 'Nombre',
        name_placeholder: 'Introduzca el nombre',
        news: 'Noticias',
        news_add: 'Añadir bloque',
        news_edit: 'Editar noticia',
        news_list: 'Lista de noticias',
        news_new: 'Nueva noticia',
        next: ' Siguiente ',
        page_config: 'Configuración de página',
        page_parent: 'Padre',
        pages: 'Páginas',
        pdf_documents: 'Documentos PDF',
        preview: 'Vista previa',
        previous: ' Anterior ',
        principal: 'Principal',
        published: 'Publicado',
        remove: 'Eliminar',
        resume: 'Resumen',
        save: 'Guardar',
        schedule: 'Programar',
        schedule_to: 'Programado',
        seo_config: 'Configuración SEO',
        seo_description: 'Descripción SEO',
        seo_description_placeholder: 'Introduzca la descripción SEO',
        seo_keywords: 'Palabras clave SEO',
        seo_keywords_placeholder: 'Introduzca las palabras clave',
        seo_keywords_small: '(separadas por comas)',
        seo_title: 'Título SEO',
        seo_title_placeholder: 'Introduzca el título SEO',
        source_image: 'Foto',
        source_text: 'Fuente',
        subtitle: 'Subtítulo',
        subtitle_placeholder: 'Introduzca el subtítulo',
        table_actions: 'Acciones',
        table_all: 'Todos',
        table_date: 'Fecha',
        table_date_modified: 'Fecha de modificación',
        table_date_published: 'Fecha de publicación',
        table_parent: 'Padre',
        table_rows_per_page: 'Registros por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_title: 'Título',
        text: 'Cuerpo de la noticia',
        title: 'Título',
        title_placeholder: 'Introduzca el título',
        upload_file_error: 'El archivo supera los 10 MB.',
        youtube_choose: 'YouTube'
    },
    'fr': {
        autor: 'Publié par',
        aaa: 'Groupe ASSEC',
        abstract: 'Sous-titre',
        add_new: 'Ajouter nouveau',
        archive: 'Archive',
        avaiable: 'Disponible jusqu\'à',
        back: ' Retour ',
        cancel: 'Annuler',
        choose_category: 'Appuyez sur ENTRÉE pour choisir la catégorie',
        close: 'Fermer',
        content: 'Actualités',
        content_add: 'Ajouter un bloc',
        content_edit: 'Modifier le contenu',
        content_list: 'Liste des actualités',
        content_new: 'Nouveau contenu',
        content_view: 'Contenu',
        creation: 'Date de création',
        dates: 'Dates',
        date_avaiable: 'Disponible jusqu\'à',
        date_creation: 'Création',
        date_last_update: 'Dernière mise à jour',
        date_publication: 'Publication',
        delete: 'Supprimer',
        delete_cancel: 'Non',
        delete_confirm: 'Oui',
        delete_error: 'Problème lors de la suppression du registre !',
        delete_success: 'Registre supprimé avec succès !',
        delete_text: 'Continuer ?',
        delete_title: 'Supprimer le registre',
        description: 'Description',
        doc_choose: 'Télécharger des PDFs',
        draft: 'Brouillon',
        edit: 'Modifier',
        edit_cancel: 'Non',
        edit_confirm: 'Oui',
        edit_error: 'Problème lors de la mise à jour du registre !',
        edit_success: 'Registre mis à jour avec succès !',
        edit_text: 'Continuer ?',
        edit_title: 'Modifier le registre',
        file_attach: 'Joindre un fichier',
        file_remove_all: 'Tout supprimer',
        file_upload: 'Téléverser le fichier',
        file_upload_all: 'Tout téléverser',
        filter_placeholder: 'Rechercher',
        id: 'ID',
        image: 'Image mise en avant',
        image_choose: 'Téléverser des images',
        images: 'Images',
        insert_cancel: 'Non',
        insert_confirm: 'Oui',
        insert_error: 'Problème lors de l\'insertion du registre !',
        insert_success: 'Registre inséré avec succès !',
        insert_text: 'Continuer ?',
        insert_title: 'Nouveau registre',
        last_mod: 'Dernière modification',
        layout: 'Type',
        multimedia: 'Multimédia',
        name: 'Nom',
        name_placeholder: 'Entrez le nom',
        news: 'Actualités',
        news_add: 'Ajouter un bloc',
        news_edit: 'Modifier la nouvelle',
        news_list: 'Liste des actualités',
        news_new: 'Nouvelle actualité',
        next: ' Suivant ',
        page_config: 'Configuration de la page',
        page_parent: 'Parent',
        pages: 'Pages',
        pdf_documents: 'Documents PDF',
        preview: 'Aperçu',
        previous: ' Précédent ',
        principal: 'Principal',
        published: 'Publié',
        remove: 'Supprimer',
        resume: 'Résumé',
        save: 'Enregistrer',
        schedule: 'Programmer',
        schedule_to: 'Programmé',
        seo_config: 'Configuration SEO',
        seo_description: 'Description SEO',
        seo_description_placeholder: 'Entrez la description SEO',
        seo_keywords: 'Mots-clés SEO',
        seo_keywords_placeholder: 'Entrez les mots-clés',
        seo_keywords_small: '(séparés par des virgules)',
        seo_title: 'Titre SEO',
        seo_title_placeholder: 'Entrez le titre SEO',
        source_image: 'Photo',
        source_text: 'Source',
        subtitle: 'Sous-titre',
        subtitle_placeholder: 'Entrez le sous-titre',
        table_actions: 'Actions',
        table_all: 'Tous',
        table_date: 'Date',
        table_date_modified: 'Date de modification',
        table_date_published: 'Date de publication',
        table_parent: 'Parent',
        table_rows_per_page: 'Enregistrements par page :',
        table_separator: 'de',
        table_state: 'État',
        table_title: 'Titre',
        text: 'Corps de la nouvelle',
        title: 'Titre',
        title_placeholder: 'Entrez le titre',
        upload_file_error: 'Le fichier dépasse 10 Mo.',
        youtube_choose: 'YouTube'

    },
}

module.exports = {
    language
};